import { Link } from 'react-router-dom';
import DramaCard from './DramaCard';
import { getTrendingDramas } from '@/mocks/dramas';

export default function TrendingSection() {
  const trendingDramas = getTrendingDramas();

  return (
    <section className="py-12 md:py-16">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-2">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500">大家都在追的热门好剧</p>
          </div>
          <Link
            to="/category/guochanju"
            className="flex items-center gap-1 text-sm text-primary-400 hover:text-primary-300 transition-colors duration-300 cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5">
          {trendingDramas.slice(0, 6).map((drama) => (
            <DramaCard key={drama.id} drama={drama} />
          ))}
        </div>
      </div>
    </section>
  );
}